module.exports = __webpack_public_path__ + "static/media/template_hands_meds.b04f0b61.webp";